import React from "react";

export function BehanceColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 10.4167C6.25 8.11562 8.11562 6.25 10.4167 6.25H39.5833C41.8844 6.25 43.75 8.11562 43.75 10.4167V39.5833C43.75 41.8844 41.8844 43.75 39.5833 43.75H10.4167C8.11562 43.75 6.25 41.8844 6.25 39.5833V10.4167Z"
        fill="#2196F3"
      />
      <path
        d="M28.125 17.7083H35.4167V19.7916H28.125V17.7083ZM22.4083 24.4041C23.0177 24.1072 24.3906 23.4312 24.3906 21.428C24.3906 17.6603 20.274 17.7093 19.5125 17.7093H12.5V32.2926H19.8177C20.4271 32.2916 25 32.1197 25 28.1239C25 25.5458 23.3229 24.702 22.4083 24.4041ZM15.625 20.2374H18.675C18.9792 20.2374 20.9615 20.3458 20.9615 21.8749C20.9615 23.403 19.4375 23.6603 18.9802 23.6603H15.625V20.2374ZM19.1 29.7614H15.5927V25.7447H19.1C19.8615 25.7447 21.5385 25.9916 21.5385 27.828C21.5385 29.6624 19.4042 29.7614 19.1 29.7614ZM33.7896 29.578C33.3052 29.8791 32.8219 30.0322 32.176 30.0322C29.7531 30.0322 29.2708 27.9895 29.2708 27.0843H37.5C37.5 26.1791 37.5 25.5103 37.3385 24.7551C37.176 23.9999 36.0729 20.8333 32.0146 20.8333C26.3427 20.8333 26.0417 25.8103 26.0417 26.5624C26.0417 27.3155 26.2042 28.2218 26.5281 28.8239C26.85 29.578 27.1729 30.1822 27.6573 30.6322C28.1406 31.0853 28.7854 31.5343 29.4312 31.8374C30.2375 32.1405 31.0448 32.2916 31.8521 32.2916C33.1417 32.2916 34.2729 31.9916 35.2406 31.3874C36.2104 30.7843 36.8552 29.8791 37.3385 28.6728H34.5958C34.4344 28.9749 34.2729 29.2749 33.7896 29.578ZM32.0146 22.9447C33.5958 22.9447 34.2729 24.603 34.4333 25.3551H29.2708C29.2708 25.2062 29.6573 22.9447 32.0146 22.9447Z"
        fill="white"
      />
    </svg>
  );
}
